import React from 'react';
import { FlexFill, FooterWrapper, Title } from './styled';
import { Button, Modal, message } from 'antd';
import { tid } from '@utils/test';
import useDeleteSavedDashboard from '../useDeleteSavedDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { getList } from '@store/dashboards/list/actions';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { replace } from 'connected-react-router';
import { homePagePath } from '../../../routers/index';
import { track } from '@utils';
import { CANCEL_DELETE_DASHBOARD_POPUP } from '@src/utils/sensor/track';
import { selector as defaultLandingPageSelector } from '@store/defaultLandingPage';
import { updateDefaultLandingPage } from '@store/defaultLandingPage/actions';
import { setLandingPage } from '@api/landingPage';
import { SAVED_DASHBOARD_PATHS, TAB_TITLE_TRENDS } from '@utils/constants';
import { get } from 'lodash';

function DeleteSavedDashboardPopup({
  isPopupOpen,
  closePopup,
  dashboardId,
  onDeleteCallback = null,
  goToHome = true,
  dashboardTypeName,
}) {
  const { baseUrl } = window.conviva;
  const { deleteSDMutation } = useDeleteSavedDashboard();
  const dispatch = useDispatch();
  const displaySuccessMessage = () => {
    message.success('Successfully Deleted!', 2);
  };

  const defaultLandingPage = useSelector(defaultLandingPageSelector);

  const urlPrefix = `${baseUrl}`;
  const nameInUrl = get(SAVED_DASHBOARD_PATHS, [dashboardTypeName], '');
  const pathnameOfDashboard = nameInUrl
    ? `${urlPrefix}/dashboard/${nameInUrl}/${dashboardId}`
    : undefined;

  const isDefaultLandingPage = pathnameOfDashboard
    ? (defaultLandingPage.url || '').endsWith(pathnameOfDashboard)
    : false;

  const callDeleteSavedDashboardHandler = async () => {
    try {
      if (isDefaultLandingPage) {
        const payload = {
          url: '',
          path: '',
          name: '',
        };

        await setLandingPage(payload);
        dispatch(updateDefaultLandingPage(payload));
      }

      await deleteSDMutation.mutateAsync(dashboardId);

      closePopup();
      displaySuccessMessage();
      dispatch(getList());
      dispatch(tempDashboardActions.remove(dashboardId, true));

      // TODO: only applicable for dashboard view, skip for options workflow
      onDeleteCallback && onDeleteCallback();

      if (goToHome) {
        dispatch(replace(homePagePath));
      }
    } catch (error) {
      // console.log('psd error', error);
      // sd-TODO: handle the error in deleting the dashboard
    }
  };

  const onCancelPopup = () => {
    closePopup();
    track({
      event: CANCEL_DELETE_DASHBOARD_POPUP,
    });
  };

  const modalTitle = <Title>Delete Dashboard</Title>;

  const footerButtons = [
    <FooterWrapper key="sd-popup-footer-wrapper" {...tid('delete-sd-popup-footer')}>
      <FlexFill />
      <Button key="sd-popup-cancel" onClick={closePopup}>
        Cancel
      </Button>
      <Button type="primary" key="sd-popup-delete" onClick={callDeleteSavedDashboardHandler}>
        OK
      </Button>
    </FooterWrapper>,
  ];

  return (
    <Modal
      title={modalTitle}
      width={600}
      open={isPopupOpen}
      okText="Save"
      cancelText="Cancel"
      footer={footerButtons}
      maskClosable={true}
      onCancel={onCancelPopup}
    >
      <p>Are you sure you want to delete the dashboard?</p>
      {isDefaultLandingPage ? (
        <p>
          If deleted then your default dashboard will reset to system default dashboard:{' '}
          {TAB_TITLE_TRENDS}.
        </p>
      ) : null}
    </Modal>
  );
}

export default DeleteSavedDashboardPopup;
